



















import {
	Component,
	Vue,
	Prop,
	Watch,
	Mixins,
	Inject
} from "vue-property-decorator";
import { ContentStreamLevelDTO, ContentStreamDTO, ContentStreamClient } from "../../Generated/ParticaAPI";
import { ContentStreamService, IContentStreamService } from "../../BusinessServices/contentstream";

import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ContentStreamLevelForm from "@/Ui-Components/ContentStream/ContentStreamLevelForm.vue";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../../Models/Buttons";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaStreamBase from "../Base/ParticaStreamBase.vue";
import { BreadcrumbItem } from "../../Models/Breadcrumb";


@Component({
	name: "ContentStreamLevel",
	components: { ContentStreamLevelForm, ParticaError, ParticaRowContainer, ParticaColumnContainer, ParticaCard, ParticaView }
})
export default class ContentStreamLevel extends ParticaStreamBase {
	@Prop() private levelid: number;
	@Prop() private id: number;
	private contentStreamService: IContentStreamService;
	private stream: ContentStreamDTO = new ContentStreamDTO();

	private level: ContentStreamLevelDTO = new ContentStreamLevelDTO(); // always init if not prop
	private buttons: ButtonConfig[] = [
		{
			label: "Update Level",
			action: eParticaAction.CONTENT_STREAM_LEVEL_SAVE,
			type: ButtonType.OK
		} as ButtonConfig,
		{
			label: "Delete Level",
			action: eParticaAction.CONTENT_STREAM_DELETE_LEVEL,
			type: ButtonType.Cancel
		} as ButtonConfig
	];
	// handle event from the actionlist
	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_LEVEL_SAVE: {
					this.level = await this.contentStreamService.saveContentStreamLevel(
						event.item
					);
					this.ShowSnackbar("Pricing level updated.");
					break;
				}
				case eParticaAction.CONTENT_STREAM_DELETE_LEVEL: {
					await this.contentStreamService.DeleteLevel(
						event.item
					);
					this.ShowSnackbar("Level deleted.");
					this.navigate("contentstreamhome", { id: this.stream.id.toString() });
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured handling event '${event.action}'`
			);
		} finally {
			this.LoadingEnd();
		}
	}

	private async init() {
		try {
			this.LoadingStart();
			this.contentStreamService = this.particaServices.getContentStreamService();
			this.stream = await this.contentStreamService.getContentStream(this.id);
			this.level = await this.contentStreamService.getContentStreamLevel(
				this.levelid
			);
			await this.getStreamNav(this.id);
			this.breadcrumbs[3].to = `/contentstream/${this.id}/levels/`;
			this.breadcrumbs[3].disabled = false;
			this.breadcrumbs.splice(4, 0, {
				text: this.level.name,
				to: `/contentstream/${this.id}/level/${this.levelid}/`,
				exact: true,
				disabled: false
			} as BreadcrumbItem);
		} catch (e) {
			this.ShowErrorDialog(e, `An error occured loading the level`);
		} finally {
			this.LoadingEnd();
		}
	}
	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}

	private async mounted() {
		this.metadata.name = "Pricing Level";
		await this.init();
	}
}
